import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// Material Dashboard 2 React components
import { Box, Tab, Tabs, Typography } from '@mui/material';
import MDBox from "components/MDBox";
import { AuthContext } from "context";
import { createMRTColumnHelper } from 'material-react-table';
import toast from 'react-hot-toast';
import MDAlert from "../../components/MDAlert";
import MDButton from "../../components/MDButton";
import MDTypography from "../../components/MDTypography";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import apiService from "../../services/api-service";
import GenericTable from "../genericTable.js";

function GeneralDocumentManagment() {
      const authContext = useContext(AuthContext);
      const navigate = useNavigate();
      const [data, setData] = useState([])
      const [dataUser, setDataUser] = useState([])
      const [activeTab, setActiveTab] = useState(0);

      const handleChange = (event, newValue) => {
        setActiveTab(newValue);
      };

      const handleSetNotification = (msg, severityType) => {
        if (severityType === 'success') {
          toast.success(msg, {id: 'general-document-managment-toast'});
        } else {
          toast.error(msg, {id: 'general-document-managment-toast'});
        }
      };

      function fetchData(){
           apiService.get('/general-security-management/', { }, {})
              .then(data => {
                if ( data ) {
                  const documents_supplier = data.filter((document) => document.category === "supplier");
                  const documents_user = data.filter((document) => document.category === "user");
                  setData(documents_supplier)
                  setDataUser(documents_user)
                }
              })
              .catch(error => handleSetNotification("Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #09930",'error'));
      }

      useEffect(() => {
          fetchData()
      }, [])

      const columnHelper = createMRTColumnHelper();

      async function deleteResource(id) {
          try {
            // Costruisci l'endpoint usando l'id fornito
            const endpoint = `/general-security-management/`;

            // Parametri opzionali per la richiesta DELETE
            const params = {id:id}; // Puoi aggiungere parametri se necessario
            const headers = {}; // Headers opzionali

            // Esegui la chiamata DELETE
            const response = await apiService.delete(endpoint, params, headers);

            // Se arriviamo qui, la chiamata è andata a buon fine
            console.log(`Risorsa con id ${id} eliminata con successo:`, response);

            // Puoi fare qualcosa con la risposta, se necessario
            return response;

          } catch (error) {
            // Gestisci eventuali errori
            console.error(`Errore durante l'eliminazione della risorsa con id ${id}:`, error.message);

            // Puoi gestire l'errore in modo specifico, ad esempio:
            if (error.message.includes('404')) {
              console.log(`La risorsa con id ${id} non è stata trovata`);
            } else if (error.message.includes('403')) {
              console.log(`Non hai i permessi per eliminare la risorsa con id ${id}`);
            }

            // Rilancia l'errore se vuoi che venga gestito a un livello superiore
            throw error;
          }
        }

      function handleDelete(id) {
          if(window.confirm("Sei sicuro di voler eliminare questo documento?\n Attenzione questa operazione è irreversibile.")) {
          deleteResource(id)
              .then(result => {
                  handleSetNotification("Operatore eliminato con successo","success")
                  fetchData()
              })
              .catch(error => {
                  // Gestisci l'errore se non è stato gestito nella funzione
                  handleSetNotification("Si è verificato un errore durante l'eliminazione del utente. Riprova più tardi se l'errore persiste contatta il supporto tecnico indicato l'errore #00032","error")
              });
          }
      }


      const columns = [
        columnHelper.accessor('name', {
          header: 'Nome documento',
          size: 120,
        }),
        columnHelper.accessor('address', {
          header: 'Modifica',
          size: 120,
          Cell: ({ row }) => (
            (authContext.hasAuth("UPSERT_GENERAL_DOCUMENTS") && <MDButton
              onClick={() => navigate("/general-document-add/"+row.original.id)}
              size="small"
            > MODIFICA </MDButton> )
          )
        }),
      ];

      return (
        <DashboardLayout>
          { authContext?.hasAuth("VIEW_GENERAL_DOCUMENTS") ?
          <>
            <DashboardNavbar/>
            <center>
              <MDBox pt={6} pb={3}>
                <MDTypography sx={{ textTransform: "uppercase" }} variant="h4" color="black">
                  DOCUMENTI GENERALI
                </MDTypography>
                 { authContext.hasAuth("UPSERT_GENERAL_DOCUMENTS") && <MDButton color={"dark"} onClick={() => navigate("/general-document-add/")}>Aggiungi documento</MDButton> }
              </MDBox>
            </center>
            <Tabs value={activeTab} onChange={handleChange} centered>
                <Tab label="Documenti aziendali"/>
                <Tab label="Documenti operatori"/>
            </Tabs>
            <TabPanel value={activeTab} index={0}>
            <MDBox pt={6} pb={3}>
                <MDTypography sx={{ textTransform: "uppercase" }} variant="h6" color="black">
                  DOCUMENTI FORNITORI
                </MDTypography>
            </MDBox>
            <GenericTable authModelName="GENERAL_DOCUMENTS" data={data} columns={columns} onDelete={handleDelete} disableButton={true}/>
            </TabPanel>
            <TabPanel value={activeTab} index={1}>
             <MDBox pt={6} pb={3}>
                <MDTypography sx={{ textTransform: "uppercase" }} variant="h6" color="black">
                  DOCUMENTI OPERATORI
                </MDTypography>
            </MDBox>
            <GenericTable authModelName="GENERAL_DOCUMENTS" data={dataUser} columns={columns} onDelete={handleDelete} disableButton={true}/>
            </TabPanel>
            </>
            :
            <MDBox mt={8}>
              <MDAlert color="error">Non hai i permessi per visualizzare questa pagina</MDAlert>
            </MDBox>
          }
        </DashboardLayout>
      );
    }


function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
        >
        {value === index && (
                <Box sx={{p: 3}}>
                    <Typography component="div">{children}</Typography>
                </Box>
            )}
        </div>
    );
}


export default GeneralDocumentManagment;
